import type { WelcomeFlowProgress } from "@app/WelcomeFlow/Types/WelcomeFlow.types";
import type { IActiveVehicle, IActiveVehicleDto } from "./IActiveVehicle";

export class ActiveVehicle implements IActiveVehicle
{

    appVehicleId: string;
    vehicleId: string;
    appConfigurationId: string;
    requiresWelcomeFlow: boolean;
    welcomeFlowProgress: WelcomeFlowProgress;
    isShared: boolean;
    verified: boolean;

    constructor( model: IActiveVehicleDto )
    {
        this.appVehicleId = model.appVehicleId;
        this.vehicleId = model.vehicleId;
        this.appConfigurationId = model.appConfigurationId;
        this.requiresWelcomeFlow = model.requiresWelcomeFlow;
        this.welcomeFlowProgress = model.welcomeFlowProgress;
        this.isShared = model.isShared;
        this.verified = model.verified;
    }
}
